import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-9" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1" }, null, -1)
const _hoisted_3 = { class: "sm:col-span-5 main-content" }
const _hoisted_4 = {
  key: 0,
  class: "question-label"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "justify-items-stretch flex flex-col slider-pink mt-8 w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Slider = _resolveComponent("Slider")!
  const _component_BackNextButtons = _resolveComponent("BackNextButtons")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content", _ctx.config.wrapperClasses])
  }, [
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            (_ctx.config.title)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _withDirectives(_createElementVNode("span", null, null, 512), [
                    [_directive_t, _ctx.config.title]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.config.textPart1)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  class: "mt-4",
                  innerHTML: _ctx.$t(_ctx.config.textPart1, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            (_ctx.config.textPart2)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 2,
                  class: "mt-4",
                  innerHTML: _ctx.$t(_ctx.config.textPart2, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true),
            _createElementVNode("p", {
              class: "mt-4",
              innerHTML: _ctx.$t(_ctx.config.question, {name: _ctx.state.nickname.value})
            }, null, 8, _hoisted_7),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_Slider, {
                class: "w-full md:w-3/4",
                min: _ctx.config.answerMin,
                max: _ctx.config.answerMax,
                step: _ctx.config.answerStep,
                value: _ctx.state.answers.value?.[_ctx.config.answerKey],
                unit: _ctx.$t(_ctx.config.answerUnit, {name: _ctx.state.nickname.value}),
                onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.answer( $event, { [_ctx.config.answerKey]: _ctx.$t(_ctx.config.question) }))),
                options: _ctx.config.answerOptions
              }, null, 8, ["min", "max", "step", "value", "unit", "options"])
            ]),
            _createVNode(_component_BackNextButtons, {
              class: "mt-auto hidden sm:block",
              "go-to": _ctx.goTo,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.answer(_ctx.state.answers.value?.[_ctx.config.answerKey]))),
              "next-screen": _ctx.config.screenNext
            }, null, 8, ["go-to", "next-screen"])
          ]),
          _createElementVNode("div", {
            class: "sm:col-span-3 h-full min-h-50vh flex-col items-center flex",
            style: _normalizeStyle(`background-image: ${_ctx.config.bgImage}; background-size: cover;  background-repeat: no-repeat; background-position: center; ${_ctx.config.bgStyles}`)
          }, null, 4),
          _createVNode(_component_BackNextButtons, {
            class: "mt-4 sm:hidden",
            "go-to": _ctx.goTo,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.answer(_ctx.state.answers.value?.[_ctx.config.answerKey]))),
            "next-screen": _ctx.config.screenNext
          }, null, 8, ["go-to", "next-screen"])
        ])
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ], 2))
}